import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import React from "react";

interface ResultProps {
  title: string;
  subtitle: string;
  extra?: React.ReactNode;
  icon: React.ReactNode;
}

export const Result = ({ icon, title, subtitle, extra }: ResultProps) => (
  <VStack spacing={3} p={6}>
    <Box width="251px" height="294px" mb={2}>
      {icon}
    </Box>

    <Heading size="md" fontWeight="bold">
      {title}
    </Heading>
    <Text color="gray.600">{subtitle}</Text>
    {extra}
  </VStack>
);
